import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { useVrmPurchaseRoDetailsModel } from "../vrmBillPurchaseRoModel";
import { formatNum } from "@/utils/utils";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { lookDesc } = useVrmPurchaseRoDetailsModel();
    const retuenText = (field: string, money: boolean = false, field2?: string) => {//field2为买赠时传入的字段
        let desc = lookDesc
        return money ? `￥${formatNum(field2 ? desc[field] + desc[field2] : desc[field])}` : formatNum(field2 ? desc[field] + desc[field2] : desc[field]);
    }
    const orderStatistics: IDescription[] = [
        {
            label: "退货总量",
            value: retuenText('numAll'),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "退货总金额",
            value: retuenText('totalAll'),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}